import React from "react";
import styles from "./ServiceAreas.module.css";
import { WHATSAPP_LINK } from "../siteData";

// Placeholder area list — edit this to match where you actually operate.
// See README.md for instructions.
const AREAS = [
  "Kuala Lumpur",
  "Petaling Jaya",
  "Subang Jaya",
  "Shah Alam",
  "Klang",
  "Puchong",
  "Cheras",
  "And nearby areas",
];

export default function ServiceAreas() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.grid}`}>
        <div className={styles.copy}>
          <p className="jc-eyebrow">Coverage</p>
          <h2 className={styles.title}>Where we work</h2>
          <p className={styles.desc}>
            Not sure if we cover your area? Message us with your location and
            we'll confirm right away.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className={`jc-btn jc-btn-dark ${styles.cta}`}
          >
            Check My Area
          </a>
        </div>

        <div className={styles.tags}>
          {AREAS.map((area) => (
            <span className={styles.tag} key={area}>
              {area}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
